import { FC } from 'react';
import { Link } from 'react-router-dom';

import { store } from 'redux/store';

import { Council, CouncilParticipant, Society, SocietyDirector } from 'types';
import { updateCouncil } from 'modules/administratives/redux/councilActions';

import { CouncilMemberAvatar } from './CouncilMemberAvatar';
import { getDirectorDetailsUrl } from '../utils/getDirectorDetailsUrl';
import { useGetParticipantAttendance } from '../../CouncilDetails/hooks/useGetParticipantAttendance';

type CouncilMembersParticipantsRowProps = {
  index: number;
  director: SocietyDirector;
  council: Council;
  society: Society;
  isAdminView: boolean;
};

type CouncilMemberAttendanceCheckboxProps = {
  index: number;
  participantAttendance: boolean;
  handleChangeAttendance: () => void;
};

const CouncilMemberAttendanceCheckbox = ({
  index,
  participantAttendance,
  handleChangeAttendance,
}: CouncilMemberAttendanceCheckboxProps) => (
  <div className="custom-control custom-control-sm custom-checkbox ml-2">
    <input
      type="checkbox"
      id={`participant-${index}`}
      className="custom-control-input"
      checked={participantAttendance}
      onChange={handleChangeAttendance}
    />
    <label className="custom-control-label" htmlFor={`participant-${index}`} />
  </div>
);

export const CouncilMembersParticipantsRow: FC<
  CouncilMembersParticipantsRowProps
> = ({ director, society, council, index, isAdminView }) => {
  const participant = council?.participants?.find(
    (participant) => participant.member === director._id
  ) as CouncilParticipant;

  const {
    data: { participantAttendance },
    actions: { setParticipantAttendance },
  } = useGetParticipantAttendance({
    participant,
  });

  const handleChangeAttendance = async () => {
    setParticipantAttendance((prev) => !prev);

    const updatedParticipants = council?.participants.map((p) => {
      if (p.member === participant.member) {
        return {
          ...p,
          assists: !participantAttendance,
          isAbsent: participantAttendance,
        };
      }

      return p;
    });

    const councilUpdateData = {
      _id: council._id,
      participants: updatedParticipants,
    };

    await store.dispatch(updateCouncil(councilUpdateData));
  };

  return (
    <li className="data-item" key={director._id}>
      {isAdminView ? (
        <>
          <Link
            to={getDirectorDetailsUrl(director, society)}
            className="data-col d-flex align-items-center text-reset text-decoration-none"
          >
            <CouncilMemberAvatar
              director={director}
              participant={participant}
              showDirectorEmail
              showDirectorType
            />
          </Link>

          <CouncilMemberAttendanceCheckbox
            index={index}
            participantAttendance={participantAttendance}
            handleChangeAttendance={handleChangeAttendance}
          />
        </>
      ) : (
        <CouncilMemberAvatar director={director} showDirectorType />
      )}
    </li>
  );
};
